import * as React from 'react';

import {TypeImplementation, Plugins} from '@packages/systems/wfdl';
import {ELiteral} from '@packages/systems/wfdl-ast';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';
import {Checkbox, HStack, InfoIcon, Tooltip} from '@packages/systems/spring';
import {updateExpressionAction} from '@packages/systems/ExpressionEditor-utils';
import {getBoolean} from '@packages/utilities/json';
import {
  ContextualExpressions,
  stripAnn,
} from '@packages/utilities/contextual-expression';
import {emotionStyled} from '@packages/utilities/styled';

const createLiteralExpr = (value: boolean) =>
  ELiteral({
    name: qualify(
      Plugins.name('Animation'),
      typeName('RiveIsTouchScrollEnabled')
    ),
    value,
  });

const HelpTooltip = emotionStyled(Tooltip)({cursor: 'help'});

export const isTouchScrollEnabled = TypeImplementation.Custom({
  render: function IsTouchScrollEnabledCheckbox({dispatch, expr}) {
    const literal = ContextualExpressions.getLiteral(stripAnn(expr));
    const state = literal ? getBoolean(literal.value) : undefined;

    return (
      <HStack spacing={1}>
        <Checkbox
          data-automation-id="rive-is-touch-scroll-enabled-checkbox"
          label="Touch scroll"
          isChecked={state}
          onChange={() =>
            dispatch(updateExpressionAction(createLiteralExpr(!state)))
          }
        />
        <HelpTooltip
          placement="bottom"
          label="Enable scrolling on touch devices when interacting with the canvas. Disable to prevent scroll behavior during touch/drag actions."
        >
          <InfoIcon colorVariant="secondary" />
        </HelpTooltip>
      </HStack>
    );
  },
  system: {
    labelVariant: 'hidden',
    defaultValue: false,
  },
});
